import ValueInterface, { SerializedValueType } from "./ValueInterface"

export const signs: string[] = ["×"]
export type ProductSign = (typeof signs)[number]

export default class ProductValue implements ValueInterface {
  constructor(
    private readonly left: ValueInterface,
    private readonly sign: ProductSign,
    private readonly right: ValueInterface,
  ) {}

  public toString(): string {
    return `${this.left.toString()} ${this.sign} ${this.right.toString()}`
  }
  public normalize(): number {
    return this.left.normalize() * this.right.normalize()
  }
  public clone(): ProductValue {
    return new ProductValue(this.left.clone(), this.sign, this.right.clone())
  }

  public toJSON(): SerializedValueType {
    return {
      type: "product",
      payload: {
        left: this.left.toJSON(),
        sign: this.sign,
        right: this.right.toJSON(),
      },
    }
  }
}
